export default __webpack_public_path__ + "assets/images/logo-2fee5bacf63703e98f94fefa65137fde.svg";